<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="60%"
    top="5vh"
    @close="close"
  >
    <div class="Minister-top" ref="box">
      <el-form ref="form" :model="form" :rules="formRules" label-width="150px">
        <div>
          <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">类目属性</div>
          </div>
          <div class="information_content">
            <el-form-item label="分类名称：" prop="templateName">
              <el-input
                placeholder="请输入分类名称"
                class="width67"
                :disabled="saveDisabled"
                v-model="form.templateName"
              ></el-input>
            </el-form-item>
            <el-form-item label="平台分类：" prop="categoryName">
              <el-input
                class="width67"
                v-model="form.categoryName"
                placeholder="请选择平台分类"
                maxlength="20"
                disabled
              ></el-input>
              <el-button
                style="margin-left: 10px"
                type="primary"
                @click="selectCategory"
              >
                选择类目
              </el-button>
            </el-form-item>
            <el-form-item label="产品属性：" prop="categoryList">
              <div class="shuxing_box">
                <div
                  class="item_shuxing"
                  v-for="(item, index) in form.categoryList || []"
                  :key="index + 'shuxingItem'"
                >
                  <el-form-item
                    :key="index + item.parameterId + 'formItem'"
                    :rules="{
                      required: item.required,
                      message: `${
                        item.type == 'dictionary' ? '请选择' : '请输入'
                      }`,
                      trigger: 'change',
                    }"
                    label-width="400px"
                    :required="item.required"
                    :label="`${item.enName}(${item.cnName})${
                      item.unit ? item.unit : ''
                    }：`"
                    :prop="`fieldValue${item.parameterId}`"
                  >
                    <!--只能输入数字-->
                    <el-input
                      :key="item.parameterId"
                      placeholder="请输入"
                      v-if="item.type == 'integer'"
                      class="shuxing_input width67"
                      v-model="form[`fieldValue${item.parameterId}`]"
                      oninput="value=value.replace(/[^0-9]/g,'')"
                      clearable
                    >
                    </el-input>
                    <!--只能输入数字 小数点-->
                    <el-input
                      :key="item.parameterId"
                      placeholder="请输入"
                      v-else-if="item.type == 'float'"
                      class="shuxing_input width67"
                      v-model="form[`fieldValue${item.parameterId}`]"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      clearable
                    >
                    </el-input>
                    <template v-else-if="item.type == 'dictionary'">
                      <el-select
                        :key="item.parameterId"
                        filterable
                        :multiple="
                          item.restrictions && item.restrictions.multipleChoices
                        "
                        v-model="form[`fieldValue${item.parameterId}`]"
                        class="shuxing_select width67"
                        clearable
                      >
                        <el-option
                          v-for="itemselect in item.parameterDictionaryList"
                          :key="itemselect.value"
                          :label="itemselect.label"
                          :value="itemselect.value"
                        ></el-option>
                      </el-select>
                    </template>
                    <el-input
                      :key="item.parameterId"
                      v-else
                      placeholder="请输入"
                      class="shuxing_input width67"
                      v-model="form[`fieldValue${item.parameterId}`]"
                      clearable
                    >
                    </el-input>
                  </el-form-item>
                  <!--                  <template-->
                  <!--                    v-if="-->
                  <!--                      item.type == 'dictionary' &&-->
                  <!--                      item.options.customValuesEnabled &&-->
                  <!--                      isInnyStart(-->
                  <!--                        form[`fieldValue${item.parameterId}`],-->
                  <!--                        item.parameterDictionaryList-->
                  <!--                      )-->
                  <!--                    "-->
                  <!--                  >-->
                  <!--                    <el-form-item-->
                  <!--                      :key="index + item.parameterId + 'formItemCustom'"-->
                  <!--                      :rules="{-->
                  <!--                        required: item.required,-->
                  <!--                        message: `请输入`,-->
                  <!--                        trigger: 'change',-->
                  <!--                      }"-->
                  <!--                      label-width="400px"-->
                  <!--                      :required="item.required"-->
                  <!--                      :label="`${item.enName}(${item.cnName})(自定义)`"-->
                  <!--                      :prop="`customValue${item.parameterId}`"-->
                  <!--                    >-->
                  <!--                      <el-input-->
                  <!--                        class="width67"-->
                  <!--                        placeholder="自定义"-->
                  <!--                        v-model="form[`customValue${item.parameterId}`]"-->
                  <!--                        maxlength="20"-->
                  <!--                      ></el-input>-->
                  <!--                    </el-form-item>-->
                  <!--                  </template>-->
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <leimu ref="leimu" @categoryAttr="getCategoryAttr"></leimu>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close" :disabled="saveDisabled">取 消</el-button>
      <el-button type="primary" @click="save" :disabled="saveDisabled"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import leimu from "./leimu";
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
  name: "createCategoryTemplate",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: "",
    },
    //当前角色
    roleInfo: {
      type: Object,
      default: () => {},
    },
    currentForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "分类模板",
      form: {
        templateName: undefined,
        categoryId: undefined,
        categoryName: undefined,
        categoryList: [],
      },
      formRules: {
        templateName: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        categoryName: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      saveDisabled: false,
    };
  },
  mounted() {},
  methods: {
    add() {
      this.reset();
    },
    edit() {
      this.reset();
      this.$nextTick(() => {
        if (this.isEdit) {
          const { templateName, categoryId, categoryName, value } =
            this.currentForm;
          Object.assign(this.form, { templateName, categoryId, categoryName });
          const valueObj = value && JSON.parse(value);
          const shuxingList = [
            ...(valueObj?.offerParameters || []),
            ...(valueObj.productParameters || []),
          ];
          for (let index = 0; index < shuxingList?.length; index++) {
            const item = shuxingList[index];
            if (item.values && !item.valuesIds) {
              this.$set(
                this.form,
                `fieldValue${item.id}`,
                item.values?.join(",")
              );
            } else {
              this.$set(
                this.form,
                `fieldValue${item.id}`,
                item.valuesIds?.join(",")
              );
              this.$set(
                this.form,
                `customValue${item.id}`,
                item.values?.join(",")
              );
            }
          }
          this.getCategoryList();
        }
      });
    },
    reset() {
      this.form = {
        templateName: undefined,
        categoryId: undefined,
        categoryName: undefined,
        categoryList: [],
      };
      this.$refs.form && this.$refs.form.resetFields();
    },
    getCategoryList() {
      const url =
        Baseurl + "/allegroCategory/getCategoryParameterAndDictionary";
      const loading = this.$loading({
        target: this.$refs.box,
        text: "正在加载产品属性...",
        background: "rgba(218,218,238,0.2)",
      });
      ajaxPost(url, { categoryId: this.form.categoryId })
        .then((res) => {
          if (res.data.code === 200) {
            const attrList = res.data.data;
            this.getCategoryAttr(
              attrList,
              this.form.categoryName,
              this.form.categoryId
            );
          }
          loading.close();
        })
        .catch(() => {
          // this.$message.error("加载失败");
          loading.close();
        });
    },

    //是否inny自定义开头【不区分大小写】
    isInnyStart(field, list) {
      if (field) {
        const str = list
          ?.find((ele) => ele.value === field)
          ?.label?.toLowerCase();
        return str?.startsWith("inny") || str?.startsWith("inna");
      }
      return false;
    },
    //选择分类
    selectCategory() {
      this.$refs.leimu.openDialog();
    },

    //获取分类数组
    getCategoryAttr(list, categoryName, categoryId) {
      try {
        Object.assign(this.form, { categoryName, categoryId });

        let arr = [];
        arr = list
          .map((item) => {
            //存放限定值  {multipleChoices:false} false单选,true多选
            if (item.restrictions) {
              item.restrictions = JSON.parse(item.restrictions);
            }
            if (item.options) {
              item.options = JSON.parse(item.options);
            }
            this.$set(
              this.form,
              `fieldValue${item.parameterId}`,
              this.form[`fieldValue${item.parameterId}`]
            );

            if (item.type == "dictionary") {
              //这个是多选
              if (item.restrictions && item.restrictions.multipleChoices) {
                this.$set(
                  this.form,
                  `fieldValue${item.parameterId}`,
                  this.form[`fieldValue${item.parameterId}`]?.split(",")
                );
              } else {
                this.$set(
                  this.form,
                  `fieldValue${item.parameterId}`,
                  this.form[`fieldValue${item.parameterId}`]
                );
              }
              this.$set(
                this.form,
                `customValue${item.parameterId}`,
                this.form[`customValue${item.parameterId}`]
              );

              const filterFlag =
                item.name === "Marka" || item.name === "Producent";
              let selectDropList = item.parameterDictionaryList; //选择的下拉数据
              if (filterFlag) {
                selectDropList =
                  (item.dictionary && JSON.parse(item.dictionary)) || [];
              }
              item.parameterDictionaryList = selectDropList.map((itemMap) => {
                return {
                  label:
                    itemMap.value +
                    (itemMap.cnValue ? "(" + itemMap.cnValue + ")" : ""),
                  value: filterFlag ? itemMap.id : itemMap.dictionaryId,
                  pinjieName: itemMap.value,
                  parameterId: item.parameterId,
                  values: undefined,
                };
              });
            }
            return item;
          })
          ?.filter((item) => {
            return (
              !(item.options && item.options.variantsAllowed) &&
              item.parameterId != "225693"
            );
          });
        this.form.categoryList = arr;
      } catch (e) {
        console.log(e);
      }
    },

    returnPushObj(item) {
      let ruturnObj = {};
      //下拉选
      if (item.type == "dictionary") {
        //多选
        if (item.restrictions && item.restrictions.multipleChoices) {
          ruturnObj.id = item.parameterId;
          ruturnObj.valuesIds = this.form[`fieldValue${item.parameterId}`];
        } else {
          ruturnObj.id = item.parameterId;
          ruturnObj.valuesIds = [this.form[`fieldValue${item.parameterId}`]];
        }
        if (
          item.options.customValuesEnabled &&
          this.isInnyStart(
            this.form[`fieldValue${item.parameterId}`],
            item.parameterDictionaryList
          )
        ) {
          if (this.form[`customValue${item.parameterId}`]) {
            ruturnObj.values = [this.form[`customValue${item.parameterId}`]];
          }
        }
      } else {
        ruturnObj.id = item.parameterId;
        ruturnObj.values = [this.form[`fieldValue${item.parameterId}`]];
      }
      return ruturnObj;
    },

    processData() {
      let productParametersJsonArray = [];
      let offerParametersJsonArray = [];
      for (let i = 0; i < this.form.categoryList?.length; i++) {
        const item = this.form.categoryList[i];
        if (item.options && item.options.describesProduct) {
          //下拉,多选且有值
          if (
            item.type == "dictionary" &&
            item.restrictions &&
            item.restrictions.multipleChoices
          ) {
            if (
              this.form[`fieldValue${item.parameterId}`] &&
              this.form[`fieldValue${item.parameterId}`]?.length > 0
            ) {
              productParametersJsonArray.push(this.returnPushObj(item));
            }
            //input输入
          } else {
            if (
              this.form[`fieldValue${item.parameterId}`] ||
              this.form[`fieldValue${item.parameterId}`] == "0" ||
              this.form[`fieldValue${item.parameterId}`] == "false"
            ) {
              productParametersJsonArray.push(this.returnPushObj(item));
            }
          }
        } else {
          //下拉,多选且有值
          if (
            item.type == "dictionary" &&
            item.restrictions &&
            item.restrictions.multipleChoices
          ) {
            if (
              this.form[`fieldValue${item.parameterId}`] &&
              this.form[`fieldValue${item.parameterId}`]?.length > 0
            ) {
              offerParametersJsonArray.push(this.returnPushObj(item));
            }
            //input输入
          } else {
            if (
              this.form[`fieldValue${item.parameterId}`] ||
              this.form[`fieldValue${item.parameterId}`] == "0" ||
              this.form[`fieldValue${item.parameterId}`] == "false"
            ) {
              offerParametersJsonArray.push(this.returnPushObj(item));
            }
          }
        }
      }
      return {
        productParameters: productParametersJsonArray,
        offerParameters: offerParametersJsonArray,
      };
    },

    save() {
      this.$refs.form.validate((valid, obj) => {
        if (valid) {
          this.saveFn();
        }
      });
    },
    async saveFn() {
      const { templateName, categoryId, categoryName } = this.form;
      const sendData = {
        id: this.currentForm.id,
        templateName,
        categoryId,
        categoryName,
        valueParameters: await this.processData(),
        staffId: this.roleInfo.rid,
        companyId: this.roleInfo.company_id,
      };
      let API =
        Baseurl + "allegroCategoryTemplate/insertAllegroCategoryTemplate";
      if (this.isEdit) {
        API = Baseurl + "allegroCategoryTemplate/updateAllegroCategoryTemplate";
      }
      this.saveDisabled = true;
      ajaxPost(API, sendData)
        .then((res) => {
          const { code } = res.data;
          if (code == 200) {
            this.$message.success(this.isAdd ? "创建成功" : "编辑成功");
            this.$emit("updateList");
            this.close();
          } else {
            this.$message.error("操作失败");
          }
          this.saveDisabled = false;
        })
        .catch(() => {
          this.$message.error("操作失败");
          this.saveDisabled = false;
        });
    },
    close() {
      this.$emit("cancelVisible");
    },
  },
  computed: {
    isAdd() {
      return this.pageType === "add";
    },
    isEdit() {
      return this.pageType === "edit";
    },
  },
  components: {
    leimu,
  },
};
</script>

<style scoped lang="scss">
@import "../ozon.less";
/deep/ .el-input.is-disabled .el-input__inner {
  color: #606266;
}
/deep/ .el-form-item .el-form-item {
  margin-bottom: 6px;
  .el-form-item__error {
    top: initial;
    bottom: -9px;
  }
}

.shuxing_box {
  min-height: 100px;
  background: rgb(238, 238, 238);
  border-radius: 10px;
  width: 88%;
  float: left;
  padding: 10px 0;
  font-size: 16px;
}
</style>
